import Vue from 'vue'
import Router from 'vue-router'
import config from '../configs'
Vue.use(Router)
let env = config.env
const route = require('./' + env).default
export default new Router(route)



// WEBPACK FOOTER //
// ./src/router/index.js